import aspectRatio from '../../aspect-ratio'

export default function (src, max, next) {
	natural(src, function (nat) {
		next(aspectRatio.fitToContainer(nat, {width: max, height: max}))
	})
}

function natural (src, next) {
	var img = new Image()
	img.onload = function () {
		next && next({
			width: img.width,
			height: img.height
		})
	}
	img.src = src
}
